import { LoadableAudit } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function AuditPage() {
  return (
    <>
      <Breadcrumb />
      <LoadableAudit />
    </>
  );
}
